
<template>
  <v-container>
    <v-row class="no-gutters">
      <v-col v-if="!entry">
        <socialite-connect-button :driver="driver"></socialite-connect-button>
      </v-col>
      <v-col v-else>
        <v-btn @click="details" color="primary">
          <v-icon left>{{getSocialiteIcon(driver)}}</v-icon>{{$t('socialiteManage.connectedWith', {name: getSocialiteName(driver)})}}<v-icon right>mdi-check</v-icon>
        </v-btn>
        <socialite-details-dialog :externalAccount="entry" :visible="showDetailsDialog" :closeAction="closeDetailsDialog"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SocialiteConnectButton from './SocialiteConnectButton.vue';
import SocialiteDetailsDialog from './SocialiteDetailsDialog.vue';
import socialiteMixin from "@/mixins/socialiteMixin"

export default {
  components: { SocialiteConnectButton, SocialiteDetailsDialog },
  mixins: [socialiteMixin],
  name: "SocialiteManage",
  props: {
    driver: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {showDetailsDialog: false}
  },
  computed: {
    entry() {
      return this.list.find((e) => {return e.driver == this.driver})
    }
  },
  methods: {
    details() {
      this.showDetailsDialog = true;
    },
    closeDetailsDialog() {
      this.showDetailsDialog = false;
    }
  }
};
</script>